// Keeps the create-course category list in step with the chosen
// source: platform courses only teach Platform knowledge; starter
// courses teach everything else. The server enforces the same pairing,
// so without JS an invalid pick just re-renders with an error.

import { onceGuard } from "./bind_once.js";

const firstBind = onceGuard();

const ROOT_SELECTOR = "[data-admin-course-form]";

export function initAdminCourseForm(root = document) {
  if (!root.querySelectorAll) return;
  root.querySelectorAll(ROOT_SELECTOR).forEach(wireForm);
}

function wireForm(form) {
  if (!firstBind(form)) return;

  // The edit form has no source select — the pairing is fixed there.
  const source = form.querySelector("[data-course-source]");
  const category = form.querySelector("[data-course-category]");
  if (!source || !category) return;

  const apply = () => {
    const platform = !!source.selectedOptions[0]?.hasAttribute(
      "data-source-platform",
    );
    let firstAllowed = null;
    for (const opt of category.options) {
      const allowed = opt.hasAttribute("data-platform-only") === platform;
      opt.hidden = !allowed;
      opt.disabled = !allowed;
      if (allowed && !firstAllowed) firstAllowed = opt;
    }
    if (category.selectedOptions[0]?.disabled && firstAllowed) {
      category.value = firstAllowed.value;
    }
  };

  source.addEventListener("change", apply);
  apply();
}
